import axios from "axios/dist/axios";
import "core-js/stable"
import "regenerator-runtime/runtime"
import qs from "qs";
import { csrfToken } from '../../../node_modules/rails-ujs/lib/assets/compiled/rails-ujs';
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken();
export default {
  methods: {
    /**
     * pathに対してgetする
     * @param  {Object} params
     * @param  {String} path
     * @param  {String} error_word
     */
    async getSelect(params, path, error_word) {
      const response = await axios
        .get(path, {
          params,
        })
        .catch((error) => {
          alert(error_word);
        });
      return response;
    },
    async postMethod(params, path, error_word) {
      const paramsSerializer = (params) => qs.stringify(params);
      const response = await axios
        .post(path, {
          params,
          paramsSerializer,
        })
        .catch((error) => {
          alert(error_word);
        });
      return response;
    },
    async patchMethod(params, path, error_word) {
      const paramsSerializer = (params) => qs.stringify(params);
      const response = await axios
        .patch(path, {
          params,
          paramsSerializer,
        })
        .catch((error) => {
          alert(error_word);
        });
      return response;
    },
    async deleteMethod(params, path, error_word) {
      const paramsSerializer = (params) => qs.stringify(params);
      const response = await axios
        .delete(path, {
          params,
          paramsSerializer,
        })
        .catch((error) => {
          alert(error_word);
        });
      return response;
    },
  },
};
